const NUNITO = '"Nunito Sans", sans-serif';

export const AUTO_TAGGING_TABLE_HEADER_HEIGHT = 48;
export const AUTO_TAGGING_TABLE_ROW_HEIGHT = 48;

const HEADER_BG = "#F9FAFB";
const ROW_HOVER_BG = "#F9FAFB";

/** Figma 4603:150195 — auto-tagging plans table */
export const AUTO_TAGGING_TABLE_SX = {
  border: "none",
  borderRadius: 0,
  fontFamily: NUNITO,
  "--DataGrid-rowBorderColor": "#F2F2F2",
  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-main": {
    position: "relative",
  },
  "& .MuiDataGrid-topContainer": {
    backgroundColor: HEADER_BG,
    borderBottom: "1px solid #F2F2F2",
  },
  "& .MuiDataGrid-topContainer::after": {
    display: "none",
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: HEADER_BG,
    minHeight: `${AUTO_TAGGING_TABLE_HEADER_HEIGHT}px !important`,
    maxHeight: AUTO_TAGGING_TABLE_HEADER_HEIGHT,
    borderBottom: "none",
  },
  "& .MuiDataGrid-columnHeaders [role='row']": {
    backgroundColor: HEADER_BG,
  },
  "& .MuiDataGrid-columnHeadersInner": {
    backgroundColor: HEADER_BG,
    borderLeft: "none !important",
    borderRight: "none !important",
  },
  "& .MuiDataGrid-columnHeadersInner, & .MuiDataGrid-columnHeader--filler": {
    backgroundColor: `${HEADER_BG} !important`,
  },
  "& .MuiDataGrid-topContainer .MuiDataGrid-filler, & .MuiDataGrid-topContainer .MuiDataGrid-scrollbarFiller":
    {
      backgroundColor: `${HEADER_BG} !important`,
    },
  "& .MuiDataGrid-scrollbarFiller--header, & .MuiDataGrid-scrollbarFiller--borderTop, & .MuiDataGrid-filler--header, & .MuiDataGrid-scrollbarFiller--pinnedRight":
    {
      backgroundColor: `${HEADER_BG} !important`,
    },
  "& .MuiDataGrid-filler, & .MuiDataGrid-scrollbarFiller": {
    backgroundColor: `${HEADER_BG} !important`,
  },
  "& .MuiDataGrid-filler--borderBottom, & .MuiDataGrid-scrollbarFiller--borderBottom":
    {
      borderBottom: "none !important",
    },
  "& .MuiDataGrid-columnHeader": {
    height: AUTO_TAGGING_TABLE_HEADER_HEIGHT,
    maxHeight: AUTO_TAGGING_TABLE_HEADER_HEIGHT,
    padding: "0 16px",
    boxSizing: "border-box",
    backgroundColor: HEADER_BG,
    borderRight: "none !important",
    borderLeft: "none !important",
    borderBottom: "none !important",
  },
  "& .MuiDataGrid-columnHeader--checkbox, & .MuiDataGrid-cell--checkbox, & .MuiDataGrid-cellCheckbox, & .MuiDataGrid-columnHeaderCheckbox": {
    minWidth: "80px !important",
    maxWidth: "80px !important",
    width: "80px !important",
  },
  '& .MuiDataGrid-columnHeader[data-field="__check__"]': {
    padding: 0,
    backgroundColor: HEADER_BG,
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    fontFamily: NUNITO,
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: 0,
    color: "#0D0D0D",
  },
  "& .MuiDataGrid-virtualScroller": {
    backgroundColor: "#FFFFFF",
  },
  "& .MuiDataGrid-virtualScroller > .MuiDataGrid-filler": {
    backgroundColor: "#FFFFFF !important",
  },
  "& .MuiDataGrid-row": {
    maxHeight: `${AUTO_TAGGING_TABLE_ROW_HEIGHT}px !important`,
    minHeight: `${AUTO_TAGGING_TABLE_ROW_HEIGHT}px !important`,
    backgroundColor: "transparent",
    cursor: "default",
  },
  "& .MuiDataGrid-row:hover": {
    backgroundColor: ROW_HOVER_BG,
  },
  "& .MuiDataGrid-row:hover .MuiDataGrid-cell": {
    backgroundColor: ROW_HOVER_BG,
  },
  "& .MuiDataGrid-row:hover .MuiDataGrid-filler": {
    backgroundColor: `${ROW_HOVER_BG} !important`,
  },
  "& .MuiDataGrid-row.Mui-selected": {
    backgroundColor: "transparent !important",
  },
  "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell": {
    backgroundColor: "transparent !important",
  },
  "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-filler": {
    backgroundColor: "transparent !important",
  },
  "& .MuiDataGrid-row.Mui-selected:hover": {
    backgroundColor: `${ROW_HOVER_BG} !important`,
  },
  "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell, & .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-filler":
    {
      backgroundColor: `${ROW_HOVER_BG} !important`,
    },
  "& .MuiDataGrid-cell": {
    fontFamily: NUNITO,
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 400,
    color: "#262626",
    padding: "0 16px",
    boxSizing: "border-box",
    borderRight: "none !important",
    borderTop: "none !important",
    backgroundColor: "transparent",
    display: "flex",
    alignItems: "center",
    maxHeight: `${AUTO_TAGGING_TABLE_ROW_HEIGHT}px !important`,
    minHeight: `${AUTO_TAGGING_TABLE_ROW_HEIGHT}px !important`,
  },
  "& .MuiDataGrid-cell--textCenter": {
    justifyContent: "center",
  },
  "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
    outline: "none",
  },
  "& .MuiDataGrid-cellCheckbox": {
    padding: 0,
  },
  "& .MuiCheckbox-root": {
    color: "#D9D9D9",
    "&.Mui-checked, &.MuiCheckbox-indeterminate": {
      color: "primary.main",
    },
  },
  "& .MuiDataGrid-footerContainer": {
    borderTop: "1px solid #F2F2F2",
    minHeight: 52,
  },
  "& .MuiTablePagination-root": {
    fontFamily: NUNITO,
    fontSize: 14,
    color: "#262626",
  },
  "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
    fontFamily: NUNITO,
    fontSize: 14,
    color: "#262626",
  },
} as const;

export const AUTO_TAGGING_STATUS_PILL_SX = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",
  minWidth: 72,
  height: 24,
  px: "10px",
  py: "4px",
  borderRadius: "9999px",
  fontFamily: NUNITO,
  fontWeight: 600,
  fontSize: 12,
  lineHeight: "12px",
} as const;

export function getAutoTaggingStatusPillColors(active: boolean): {
  backgroundColor: string;
  color: string;
} {
  return active
    ? { backgroundColor: "#E8F1FF", color: "#295EF1" }
    : { backgroundColor: "#F5F5F5", color: "#595959" };
}
